import {
  Button,
  Flex,
  Icon,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { Field, Form } from "react-final-form";
import InputField from "../../../fields/InputField";
import SelectField from "../../../fields/SelectField";
import { createMassUsersValidator as validate } from "./validators";
import { FieldArray } from "react-final-form-arrays";
import arrayMutators from "final-form-arrays";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { ROLES_OPTION } from "../../../../utils/constants";
import SelectBarangayField from "../../../fields/SelectBarangayField";
import { AuthContext } from "../../../../context/AuthContext";
import SelectProvincesField from "../../../fields/SelectProvincesField";
import SelectCityFieldField from "../../../fields/SelectCityField";

type UserMassCreateFormProps = {
  onSubmit: (...params: any) => void;
  formName?: string;
  initialValues?: any;
  isAdmin?: boolean;
};

const UserMassCreateForm = (props: UserMassCreateFormProps) => {
  const { onSubmit, formName, initialValues, isAdmin } = props;
  const [province_code, setProvinceCode] = useState();
  const [city_code, setCityCode] = useState();

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      mutators={{ ...arrayMutators }}
      initialValues={initialValues}
    >
      {({
        handleSubmit,
        form: {
          mutators: { push, pop }, // injected from final-form-arrays above
        },
      }) => (
        <form onSubmit={handleSubmit} id={formName}>
          <TableContainer>
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Name</Th>
                  {isAdmin && (
                    <>
                      <Th>Role</Th>
                      <Th>Phone</Th>
                      <Th>Email</Th>
                    </>
                  )}

                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                <FieldArray name="users">
                  {({ fields }) =>
                    fields.map((name, index) => {
                      return (
                        <Tr key={name}>
                          <Td>
                            <Field
                              name={`${name}.name`}
                              component={InputField}
                            />
                          </Td>
                          {isAdmin && (
                            <>
                              <Td>
                                <Field
                                  name={`${name}.role`}
                                  component={SelectField}
                                  options={ROLES_OPTION}
                                  menuPortalTarget={document.body}
                                />
                              </Td>
                              <Td>
                                <Field
                                  name={`${name}.phone`}
                                  type="tel"
                                  component={InputField}
                                />
                              </Td>
                              <Td>
                                <Field
                                  name={`${name}.email`}
                                  type="email"
                                  component={InputField}
                                />
                              </Td>
                            </>
                          )}

                          <Td isNumeric>
                            <Button
                              mr="3"
                              onClick={() => pop("users", undefined)}
                            >
                              <Icon as={MinusIcon} />
                            </Button>
                          </Td>
                        </Tr>
                      );
                    })
                  }
                </FieldArray>
              </Tbody>
            </Table>
            <Flex p="6" justifyContent="end">
              <Button mr="3" onClick={() => push("users", undefined)}>
                <Icon as={AddIcon} />
              </Button>
            </Flex>
          </TableContainer>
        </form>
      )}
    </Form>
  );
};

export default UserMassCreateForm;
